import { render } from "./PurchaseReceiveList.vue?vue&type=template&id=53278994"
import script from "./PurchaseReceiveList.vue?vue&type=script&lang=js"
export * from "./PurchaseReceiveList.vue?vue&type=script&lang=js"

import "./PurchaseReceiveList.vue?vue&type=style&index=0&id=53278994&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__